import { render, staticRenderFns } from "./xkgcDetail.vue?vue&type=template&id=4dd71fd2&scoped=true&"
import script from "./xkgcDetail.vue?vue&type=script&lang=js&"
export * from "./xkgcDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaDetails.less?vue&type=style&index=0&id=4dd71fd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd71fd2",
  null
  
)

component.options.__file = "xkgcDetail.vue"
export default component.exports